(() => {
  if (customElements.get('elastica-cart-gift')) return;
  const marker = '600-duvet';
  let running = false;
  let blocked = false;
  let queued = false;
  let failedSignature = '';
  let errorMessage = '';
  let config;
  const root = () => window.Shopify.routes.root;
  const managed = item => item.properties?._elastica_gift === marker;
  const paintError = () => {
    document.querySelectorAll('elastica-cart-gift').forEach(element => {
      const error = element.querySelector('[data-elastica-gift-error]');
      if (error) {
        error.textContent = errorMessage;
        error.hidden = !errorMessage;
      }
      if (errorMessage) {
        const status = element.querySelector('[data-elastica-gift-status]');
        if (status) status.textContent = errorMessage;
        if (error) error.hidden = true;
      }
    });
  };
  const request = async (path, body) => {
    const response = await fetch(root() + path, body ? {
      method: 'POST', headers: {'Content-Type': 'application/json'}, body: JSON.stringify(body)
    } : {cache: 'no-store'});
    const data = await response.json();
    if (!response.ok || data.errors) throw new Error(data.description || 'Cart request failed');
    return data;
  };
  const sections = () => {
    const ids = [];
    document.documentElement.dispatchEvent(new CustomEvent('cart:bundled-sections', {bubbles: true, detail: {sections: ids}}));
    return [...new Set(ids)].slice(0, 5);
  };
  const refresh = async () => {
    const cart = await request('cart/update.js', {sections: sections()});
    theme.pubsub.publish(theme.pubsub.PUB_SUB_EVENTS.cartUpdate, {source: 'elastica-gift', cart});
  };
  const signature = cart => JSON.stringify([cart.currency, cart.total_price, cart.items.filter(item => !managed(item)).map(item => [item.key, item.quantity, item.final_line_price]), cart.discount_codes]);
  const synchronize = async () => {
    if (running) { queued = true; return; }
    if (!config || (!config.enabled && !config.hasManaged)) return;
    running = true;
    document.documentElement.setAttribute('data-elastica-cart-busy', '');
    let changed = false;
    try {
      let cart = await request('cart.js');
      const eligible = cart.total_price - cart.items.filter(item => managed(item) || item.variant_id === config.variant).reduce((total, item) => total + item.final_line_price, 0);
      const qualifies = config.enabled && cart.currency === 'EUR' && eligible >= config.threshold && config.threshold > 0;
      const gifts = cart.items.filter(managed);
      const invalid = gifts.filter((item, index) => !qualifies || item.final_line_price !== 0 || item.quantity !== 1 || index > 0 || item.variant_id !== config.variant);
      for (const item of invalid) {
        await request('cart/change.js', {id: item.key, quantity: 0});
        changed = true;
      }
      if (changed) cart = await request('cart.js');
      const currentSignature = signature(cart);
      if (currentSignature !== failedSignature) errorMessage = '';
      if (qualifies && !cart.items.some(item => item.variant_id === config.variant || managed(item)) && currentSignature !== failedSignature) {
        try {
          await request('cart/add.js', {items: [{id: config.variant, quantity: 1, properties: {_elastica_gift: marker}}]});
          changed = true;
          cart = await request('cart.js');
          const added = cart.items.filter(managed);
          if (!added.length || added.some(item => item.final_line_price !== 0)) {
            for (const item of added) await request('cart/change.js', {id: item.key, quantity: 0});
            failedSignature = signature(await request('cart.js'));
            errorMessage = config.error;
          }
        } catch (error) {
          failedSignature = currentSignature;
          errorMessage = config.error;
          throw error;
        }
      }
      if (changed) await refresh();
      blocked = false;
    } catch (error) {
      blocked = true;
      errorMessage = config.error;
      console.error('Elastica gift synchronization:', error);
    } finally {
      running = false;
      document.documentElement.removeAttribute('data-elastica-cart-busy');
      paintError();
      if (queued) { queued = false; synchronize(); }
    }
  };
  document.addEventListener('cart:updated', event => {
    if (!running) synchronize();
    else queued = true;
  });
  document.addEventListener('click', event => {
    if ((running || blocked) && event.target.closest('[name="checkout"], a[href*="/checkout"]')) {
      event.preventDefault(); event.stopImmediatePropagation();
      const status = document.querySelector('[data-elastica-gift-status]');
      if (status) status.textContent = config.busy;
      if (!running) synchronize();
    }
  }, true);
  document.addEventListener('submit', event => {
    if ((running || blocked) && (event.submitter?.name === 'checkout' || event.target.action?.includes('/checkout'))) {
      event.preventDefault(); event.stopImmediatePropagation();
      if (!running) synchronize();
    }
  }, true);
  customElements.define('elastica-cart-gift', class extends HTMLElement {
    connectedCallback() {
      config = {hasManaged: this.dataset.hasManaged === 'true', enabled: this.dataset.enabled === 'true', variant: Number(this.dataset.variant), threshold: Number(this.dataset.threshold), error: this.dataset.error, busy: this.dataset.busy};
      paintError();
      if (!running) synchronize();
    }
  });
})();
